import { Component, Input } from '@angular/core';
import { ResponsiveService } from '../../../services/responsive.service';
import { TranslatePipe } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-workplan-date',
  imports: [TranslatePipe, RTLDivDirectiveDirective, MatDividerModule],
  templateUrl: './workplan-date.html',
  styleUrl: './workplan-date.scss',
})
export class WorkplanDate {
  isMobile: Boolean;
  displayedDate:string;
  @Input() dateSelected;

  constructor(private responsiveService: ResponsiveService) { }

  ngOnInit() {
    this.onResize();
		this.responsiveService.checkWidth();
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}
}
